import { dtRum } from './dtRum';
/**
 * Função responsável por enviar um erro que ocorreu no código, geralmente o erro de um try/catch
 */
export function dynatraceCustomError(error) {
    var pref = 'Custom Error';
    var isErrorString = typeof error === 'string';
    var errorReport = isErrorString
        ? "".concat(pref, " - ").concat(error)
        : new Error(pref, {
            cause: error,
        });
    dtRum === null || dtRum === void 0 ? void 0 : dtRum.reportError(errorReport);
}
//# sourceMappingURL=dynatraceCustomError.js.map